export const decodeURIText = (text) => {
  //   return decodeURI(text)
  if (typeof text !== "string") return text;
  return text
    .replaceAll("%20", " ")
    .replaceAll("%F0%9F%93%B7", "📷")
    .replaceAll("%E2%80%A6", "...")
    .replaceAll("%28", "(")
    .replaceAll("%25", "%")
    .replaceAll("%29", ")")
    .replaceAll("%0A", " ")
    .replaceAll("%E2%9A%A0", "⚠")
    .replaceAll("%F0%9F%8F%83", "🏃")
    .replaceAll("%3A", ":")
    .replaceAll("%2F", "/")
    .replaceAll("%21", "!")
    .replaceAll("%2B", "+")
    .replaceAll("+", " ")
    .replaceAll(/<(Tab|Enter|Backspace|Delete|Insert|Home|End|PageUp|PageDown|Left|Right|Up|Down|Ctrl|Shift|Alt|Meta|CapsLock|NumLock|ScrollLock|Esc|Space|F[1-9]|F1[0-2])>/g, '')
    .trim();
};
